export default __webpack_public_path__ + "static/helix-46fd5cd33119595fe28e997fbc67f1b3.svg";